import React, { Component } from 'react'
import { Table, Tooltip, Modal, Checkbox, message, Collapse, Form, Select, Input, DatePicker, Button, Card, Badge } from 'antd'
import { connect } from 'dva'
import { Link } from 'dva/router'
import moment from 'moment'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import Currency from 'react-currency-formatter';
import { all, get, update } from '../../services/restApi'
import { getTotal } from '../../utils'
import config from '../../utils/config'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const Panel = Collapse.Panel
const FormItem = Form.Item;
const Option = Select.Option;
const RangePicker = DatePicker.RangePicker;
const ButtonGroup = Button.Group;

class boucher_adon extends Component {

    constructor (props) {
        super(props);

        this.state = {
            query: {},
            hotels: [],
            showModalBoucherDetails: false
        }

        message.config({top: 110, duration: 4});

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {

        let query = {};

        if (this.props.app.user.type === 'recepcionista') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 20}).then((resp) => {
            this.setState({
                hotels: resp.results
            });
        })
    }


    /**
    * Carga otro bloque de registros
    */
    loadMore () {
        if (this.props.boucher_adon.skip < this.props.boucher_adon.total_items) {

            if (this.state.currentHotel) {
                this.setState({query: {
                    ...this.state.query, 
                    hotel: {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}
                }});
            }

            if (this.props.app.user.type === 'recepcionista') {
                this.setState({query: {
                    createdBy: {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId},
                }});
            }

            this.props.dispatch({type: 'boucher_adon/query', payload: {
                where: this.state.query,
                skip: this.props.boucher_adon.skip,
                limit: this.props.boucher_adon.limit,
                count: 1,
                order: '-requestedAt'
            }});
        }
    }


    /**
    * Elimina un registro
    */
    delete_item (item) {
        let dispatch = this.props.dispatch

        confirm({
            title: '¿Estás seguro que deseas eliminar la boucher?',
            onOk () {
                dispatch({type: 'boucher_adon/removeItem', payload: item});
            }
        })
    }



    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {

        let query = { name: {$regex: '(?i)' + value} };

        if (this.props.app.user.type === 'recepcionista') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        setTimeout(() => {
            all('Hotel', {where: query}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Muestra el modal de los detalles del cliente
    */
    showBoucherDetails (id) {
        this.props.dispatch({type: 'app/showLoading'})

        get('BoucherAdon', id, {include: 'adons,hotel,createdBy'}).then((resp) => {

            this.setState({ currentBoucher: resp });
            this.props.dispatch({type: 'app/hideLoading'})
            this.setState({ showModalBoucherDetails: true });

        }).catch(e => {
            this.props.dispatch({type: 'app/hideLoading'})
            message.error('Ha ocurrido un error al consultar la información. Intente más tarde')    
        });
    }

    hideModalBoucherDetails () { this.setState({ showModalBoucherDetails: false }); }



    /**
    * Búsqueda
    */
    search (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Limpiamos los valores de consulta antes de realizar el filtro
            let query = {};
            query = _.omit(query, ['hotel', 'client', 'reservation', 'requestedAt'])

            // Query
            if (values.hotel && values.hotel.key) {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key};
            }

            if (this.props.app.user.type === 'recepcionista') {
                query.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId}
            }

            if (values.client)
                query.client = {$regex: '(?i)' + values.client}

            if (values.reservation)
                query.reservation = values.reservation

            if (values.folio) {
                query.adons = {
                    $inQuery: {
                        where: {
                            id: values.folio
                        },
                        className: 'BoucherAdonItem'
                    }
                }
            }

            if (values.date && values.date[0] && values.date[1]) {
                query.requestedAt ={
                    $gte: {__type: 'Date', iso: new Date(values.date[0])},
                    $lte: {__type: 'Date', iso: new Date(values.date[1])}
                }
            }


            this.setState({query: query});

            this.props.dispatch({type: 'boucher_adon/filter', payload: {
                where: query,
                skip: 0,
                limit: this.props.boucher_adon.limit,
                count: 1,
                order: '-requestedAt'
            }});
        })
    }


    /**
    * Imprime el boucher
    */
    print_boucher () {
        window.print();
    }


    /**
    * Render del componente
    */
    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        Bouchers de servicios

                        <div className="pull-right">
                            <Button type='primary'>
                                <Link to="/adons/new-adon" className=""><Icon name="plus" /> Reservar servicios</Link>
                            </Button>
                        </div>
                    </h1>
                </section>

                <section className="content hidden-print">

                    <Collapse defaultActiveKey={['0']} className="marginBottom20">
                        <Panel header="Búsqueda" key="1">
                            <Form onSubmit={this.search.bind(this)}>
                                <div className="row">
                                    {!this.state.currentHotel 
                                        ? <div className="col-md-2">
                                            <FormItem label="Hotel" hasFeedback>
                                                {this.props.form.getFieldDecorator('hotel')(
                                                    <Select 
                                                        size='large'
                                                        mode="combobox"
                                                        onChange={this.handleSelectHotelChange.bind(this)}
                                                        filterOption={false}
                                                        labelInValue={true}
                                                        optionLabelProp='label'
                                                        placeholder="Elija el hotel"
                                                        >
                                                        {hotel_options}
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    }

                                    <div className="col-md-2">
                                        <FormItem label="Cliente" hasFeedback>
                                            {this.props.form.getFieldDecorator('client')(<Input size='large' placeholder="Escriba el nombre del cliente" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="# de Reservación" hasFeedback>
                                            {this.props.form.getFieldDecorator('reservation')(<Input size='large' placeholder="Omita escribir el ID-" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Folio de actividad" hasFeedback>
                                            {this.props.form.getFieldDecorator('folio')(<Input size='large' placeholder="Escriba el folio" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-4">
                                        <FormItem label="Fecha del servicio" hasFeedback>
                                            {this.props.form.getFieldDecorator('date')(
                                                <RangePicker 
                                                    format="DD-MM-YYYY"
                                                    onOk={resp => {
                                                        console.log(resp);
                                                    }} />
                                            )}
                                        </FormItem>
                                    </div>
                                </div>

                                <div className="row text-center paddingBottom30">
                                    <Button type='primary' onClick={this.search.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                        Buscar...
                                    </Button>
                                </div>
                            </Form>
                        </Panel>
                    </Collapse>

                    <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                        <div className="box-body">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="table-responsive table">

                                        <InfiniteScroll
                                            padding={50}
                                            throttle={100}
                                            onScroll={() => this.loadMore()}>

                                            <Table 
                                                dataSource={this.props.boucher_adon.boucher_adons} 
                                                rowKey="objectId" 
                                                size="middle" 
                                                loading={this.props.app.loadingTable} 
                                                pagination={false}
                                                rowClassName={(record, index) => {
                                                    if (record.finished) {
                                                        return 'finished'
                                                    }
                                                }}>

                                                {/*<Column title="Fecha de creación" key="createdAt" render={(item) => (
                                                    <span>{moment(item.createdAt).format('ll')}</span>
                                                )} />*/}
                                                <Column title="Fecha del servicio" key="requestedAt" render={(item) => (
                                                    <span>{moment(item.requestedAt.iso).format('ll')}</span>
                                                )} />
                                                <Column title="Hotel" key="hotel" render={(item) => (
                                                    <span>{item.hotel ? item.hotel.name : '-'}</span>
                                                )} />
                                                {this.props.app.user && this.props.app.user.type !== 'recepcionista'
                                                  ? <Column title="Creado por" key="createdBy" render={(item) => (
                                                        <span>{item.createdBy ? item.createdBy.name : '-'}</span>
                                                    )} />
                                                    : ''
                                                }
                                                <Column title="Nombre del cliente" key="client" render={(item) => (
                                                    <span>{item.client}</span>
                                                )} />
                                                <Column title="# de reservación" key="reservation" render={(item) => (
                                                    <span>ID-{item.reservation}</span>
                                                )}/>
                                                <Column title="Total" key="total" render={(item) => (
                                                    <Currency quantity={item.adons && item.adons.length > 0 ? getTotal(item.adons, 'total') : 0} currency="USD" />
                                                )} />
                                                <Column title="Acciones" key="action" width={145}
                                                    render={(item) => (
                                                        <span className="actions">
                                                            <ButtonGroup>
                                                                {/*<Tooltip placement="bottom" title="Editar">
                                                                    <Button>
                                                                        <Link to={`/adons/details/${item.objectId}`}><Icon name="edit" /></Link>
                                                                    </Button>
                                                                </Tooltip>*/}

                                                                <Tooltip placement="bottom" title="Ver detalles">
                                                                    <Button>
                                                                        <Link onClick={() => { this.showBoucherDetails(item.objectId) }}><Icon name="search" /></Link>
                                                                    </Button>
                                                                </Tooltip>

                                                                {!this.state.currentHotel
                                                                    ? <Tooltip placement="bottom" title="Eliminar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.delete_item(item) }} className=""><Icon name="trash" /></Link>
                                                                        </Button>
                                                                    </Tooltip>
                                                                    : ''
                                                                }
                                                            </ButtonGroup>
                                                        </span>
                                                    )}
                                                />
                                            </Table>        
                                        </InfiniteScroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Modal
                    className="hidden-print"
                    visible={this.state.showModalBoucherDetails}
                    title="Detalles"
                    onCancel={this.hideModalBoucherDetails.bind(this)}
                    footer={[
                        <Button key="back" onClick={this.hideModalBoucherDetails.bind(this)}>Cerrar</Button>
                    ]}
                >
                    {this.state.currentBoucher
                        ? <div>
                            <Card title="Reservación de servicios adicionales" className="marginBottom20">
                                <div>
                                    <div className="row print-header" style={{borderBottom: '1px solid #f3f3f3', paddingBottom: '15px'}}>
                                        <div className="col-md-6 col-print-6">
                                            {this.state.currentBoucher.hotel && this.state.currentBoucher.hotel.picture
                                                ? <img src={config.externalUrl + 'uploads/hotels/' + this.state.currentBoucher.hotel.picture} style={{width: 'auto', height: '70px'}} />
                                                : ''
                                            }
                                        </div>

                                        <div className="col-md-6 col-print-6">
                                            <div style={{textAlign: 'right', marginTop: '20px'}}>
                                                {this.state.currentBoucher.requestedAt 
                                                    ? moment(this.state.currentBoucher.requestedAt.iso).format('ll')
                                                    : ''
                                                }
                                            </div>
                                        </div>

                                        {this.state.currentBoucher.hotel
                                            ? <div className="col-md-12 col-print-12" style={{marginTop: '15px', textAlign: 'justify'}}>
                                                <p>
                                                    Trie Hotels le da la bienvenida a nuestro hotel {this.state.currentBoucher.hotel.name}, {this.state.currentBoucher.hotel.city}.<br />
                                                    A continuación encontrará una relación de las actividades que ha contratado durante su estadía con nosotros.<br />
                                                    Le pedimos presentar de forma individual el ticket de la actividad que desea realizar.
                                                </p>

                                                <p style={{marginTop: '15px'}}>
                                                    <small>*Estos tickets son individuales y no podrán ser utilizados por otro huésped que no sea parte de la reservación.<br />
                                                    * Estos tickets no podrán ser reimpresos o fotocopiados.<br />
                                                    * Los tickets solo podrán ser utilizados durante el periodo de su reservación</small>
                                                </p>
                                            </div>
                                            : ''
                                        }
                                    </div>

                                    <div className="row">
                                        {this.state.currentBoucher.adons.map((item) => (
                                            <div key={item.id} className="col-md-12 col-print-12 activity-grid">
                                                {this.state.currentBoucher.hotel && this.state.currentBoucher.hotel.picture
                                                    ? <img src={config.externalUrl + 'uploads/hotels/' + this.state.currentBoucher.hotel.picture} className="watermark" />
                                                    : ''
                                                }

                                                <div className="col-md-6 col-print-6">
                                                    <label>Folio:</label> <code>{item.id}</code> <br />
                                                    <label>Nombre:</label> {this.state.currentBoucher.client ? this.state.currentBoucher.client : ''} <br />
                                                    <label># Reservación:</label> {this.state.currentBoucher.reservation ? this.state.currentBoucher.reservation : ''} <br />
                                                    <label>Fecha:</label> {this.state.currentBoucher.requestedAt ? moment(this.state.currentBoucher.requestedAt.iso).format('ll') : ''}
                                                </div>

                                                <div className="col-md-6 col-print-6">
                                                    {item.adon.name} <Currency quantity={item.adon.price ? item.adon.price : 0} currency="USD" /> <br />
                                                    <label>PAX:</label> {item.pax} <br />
                                                    <label>Total:</label> <Currency quantity={item.pax && item.adon.price ? item.pax * item.adon.price : 0} currency="USD" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Card>
                        </div>
                        : ''
                    }
                </Modal>

                {/* Se duplico este código (identico al del modal) ya que éste es el que se imprime sin que perjudique los estilos del modal */}
                {this.state.currentBoucher
                    ? 
                    <div className="col-md-12">
                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-body main-print margin-print">
                                <div className="row print-header" style={{borderBottom: '1px solid #f3f3f3', paddingBottom: '15px'}}>
                                    <div className="col-md-6 col-print-6">
                                        {this.state.currentBoucher.hotel && this.state.currentBoucher.hotel.picture
                                            ? <img src={config.externalUrl + 'uploads/hotels/' + this.state.currentBoucher.hotel.picture} style={{width: 'auto', height: '70px'}} />
                                            : ''
                                        }
                                    </div>

                                    <div className="col-md-6 col-print-6">
                                        <div style={{textAlign: 'right', marginTop: '20px'}}>
                                            {this.state.currentBoucher.requestedAt 
                                                ? moment(this.state.currentBoucher.requestedAt.iso).format('ll')
                                                : ''
                                            }
                                        </div>
                                    </div>

                                    {this.state.currentBoucher.hotel
                                        ? <div className="col-md-12 col-print-12" style={{marginTop: '15px', textAlign: 'justify'}}>
                                            <p>
                                                Trie Hotels le da la bienvenida a nuestro hotel {this.state.currentBoucher.hotel.name}, {this.state.currentBoucher.hotel.city}.<br />
                                                A continuación encontrará una relación de las actividades que ha contratado durante su estadía con nosotros.<br />
                                                Le pedimos presentar de forma individual el ticket de la actividad que desea realizar.
                                            </p>

                                            <p style={{marginTop: '15px'}}>
                                                <small>*Estos tickets son individuales y no podrán ser utilizados por otro huésped que no sea parte de la reservación.<br />
                                                * Estos tickets no podrán ser reimpresos o fotocopiados.<br />
                                                * Los tickets solo podrán ser utilizados durante el periodo de su reservación</small>
                                            </p>
                                        </div>
                                        : ''
                                    }
                                </div>

                                <div className="row">
                                    {this.state.currentBoucher.adons.map((item) => (
                                        <div key={item.id} className="col-md-12 col-print-12 activity-grid">
                                            {this.state.currentBoucher.hotel && this.state.currentBoucher.hotel.picture
                                                ? <img src={config.externalUrl + 'uploads/hotels/' + this.state.currentBoucher.hotel.picture} className="watermark" />
                                                : ''
                                            }

                                            <div className="col-md-6 col-print-6">
                                                <label>Folio:</label> <code>{item.id}</code> <br />
                                                <label>Nombre:</label> {this.state.currentBoucher.client ? this.state.currentBoucher.client : ''} <br />
                                                <label># Reservación:</label> {this.state.currentBoucher.reservation ? this.state.currentBoucher.reservation : ''} <br />
                                                <label>Fecha:</label> {this.state.currentBoucher.requestedAt ? moment(this.state.currentBoucher.requestedAt.iso).format('ll') : ''}
                                            </div>

                                            <div className="col-md-6 col-print-6">
                                                {item.adon.name} <Currency quantity={item.adon.price ? item.adon.price : 0} currency="USD" /> <br />
                                                <label>PAX:</label> {item.pax} <br />
                                                <label>Total:</label> <Currency quantity={item.pax && item.adon.price ? item.pax * item.adon.price : 0} currency="USD" />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    : ''
                }
            </div>
        )
    }
}

export default connect(({boucher_adon, app}) => ({boucher_adon, app}))(Form.create()(boucher_adon))


// WEBPACK FOOTER //
// ./src/components/adons/index.js